import { useEffect, useState } from 'react'
import { useGetWellData } from '../../../hooks/use-api'
import { useWellId } from '../../../hooks/use-well-id'
import { CheckableField, FormField, InlineNotification } from '@msaf/core-react'

export default function DetailsTabView() {
  const wellId = useWellId()
  // Fetch the state required to display the UI in view mode
  const url = `wells/${wellId}/lithology/view`
  const stateQueryResult = useGetWellData(url)
  const [fields, setFields] = useState<{
    hasNoStrataRecords: boolean
    isStrataRequired: boolean
  }>({
    hasNoStrataRecords: false,
    isStrataRequired: false,
  })

  const { isLoading, isSuccess, data } = stateQueryResult

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields({
        hasNoStrataRecords: !!data.state.hasNoStrataRecords,
        isStrataRequired: !!data.state.isStrataRequired,
      })
    }
  }, [isSuccess, data?.state])

  return (
    <>
      <FormField isSkeleton={isLoading} label='No strata have been added.' labelId='no-strata-label'>
        {!fields.isStrataRequired ? (
          <CheckableField
            isSkeleton={isLoading}
            type='checkbox'
            id='no-strata-to-be-added-id'
            name='no-strata-to-be-added'
            label='There is no strata information available for this record'
            checked={fields.hasNoStrataRecords}
            disabled={true}
          />
        ) : (
          <InlineNotification isDismissable={false} messageType='info'>
            At least one strata layer must be added for existing or decommissioned well.
          </InlineNotification>
        )}
      </FormField>
    </>
  )
}
